import { SET_ACTIVATEUSER } from '../actions';

const changestatus = (state = [], action) => {
  switch (action.type) {
	case SET_ACTIVATEUSER:
      return [...action.value];  
    default: return state;
  }
}

export default changestatus;
